module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Born in 1962, Melbourne, Australia, the author has lived on a small island in South East Queensland, Australia, since 2007. She studied and worked in Sweden for five years before returning to Australia with her two sons. She worked in media and charity before undertaking studies in social science and neuro-linguistic programming, becoming a qualified councillor and international life coach. She was awarded the Hazel Hawke Scholarship to study at Curtin University and went on to work with primary school students, mentoring and working primarily in areas of social skilling and behaviour.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Inspired by her environment and her students, the author wrote the first book of the ‘Mangrove Sands’ series after retirement in 2018. She self-published a book about her beloved canine, Sir Charles Barkley, who died in 2020, donating the proceeds from sales to WIRES animal rescue.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("The author continues to write children’s books at her peaceful island home in South East Queensland.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0